import { render, staticRenderFns } from "./shenpan.vue?vue&type=template&id=e03469da"
import script from "./shenpan.vue?vue&type=script&lang=ts"
export * from "./shenpan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports